import React, { useState, useEffect } from "react";
// import { FaEye } from "react-icons/fa";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import RSearchBar from "material-ui-search-bar";
import bulb from "../../assets/images/Vector.png";
import axios from "axios";
import constantObject from "../../config";
import { Tooltip } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import { IoHelpCircleOutline } from "react-icons/io5";
import { localTimeConvert, formatTimes } from "../../common/Functions";
import { RiSearchLine } from 'react-icons/ri';
import toast, { Toaster } from 'react-hot-toast';
import { IoMdCopy } from "react-icons/io";
import "./index.scss";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import Loader from "../../components/Loader";
// import AdSense from 'react-adsense';

const NewTransactions = () => {
  const [cardValue, setCardValue] = useState({});
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [query, setQuery] = useState('');

  const history = useHistory();

  const cardData = [
    {
      title: "Transactions (24H)",
      // value: `${cardValue.txnCount24Hours} <span class='card-substyle'>(5.02%)</span>`,
      value: `${cardValue.txnCount24Hours}`,
    },
    {
      title: "Pending Transactions (Last 1H)",
      value: `0`,
    },
    {
      title: "Network Transactions Fee (24H)",
      value: `${cardValue.txnFees24Hours}`,
    },
    {
      title: "Avg. Transaction Fee (24h)",
      value: `${cardValue.avgTxnFee24Hours}`,
    },
  ];

  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //get card key
  const getTransactionCardKey = async () => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/stats/supported_queries`
      );

      getTransactionCardValue(response.data);
    } catch (error) {
      console.log("Error fetching card key data:", error);
    }
  };

  //get card value
  const getTransactionCardValue = async (val) => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/stats/detail?query=${val[9]},${val[8]},${val[11]},${val[10]},${val[3]}`
      );

      setCardValue(response.data);
    } catch (error) {
      console.log("Error fetching card value data:", error);
    }
  };

  // Function to fetch updated transaction data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${
            constantObject.BaseUrl
          }/api/transaction?limit=${rowsPerPage}&page=${page + 1}`
        );

        const { data, totalCount } = response.data;

        setTableData(data);
        setTotalCount(totalCount);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    // Fetch data immediately on mount
    fetchData();

    // Set up interval for fetching updated data
    const intervalId = setInterval(fetchData, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [page, rowsPerPage]);

  useEffect(() => {
    getTransactionCardKey();
  }, []);

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/search?id=${query}&limit=${rowsPerPage}&page=${page + 1}`
      );

      if (response?.status === 200) {
        if (response?.data?.type === "BLOCK") {
          history.push(`/block_details/${response?.data?.data?.blockNumber}`);
        } else if (response?.data?.type === "TXN_HASH") {
          history.push(`/transactions_detail/${response?.data?.data?.hash}`);
        } else if (response?.data?.type === "ACC_ADDRESS") {
          history.push(`/address/${response?.data?.data?.address}`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // press on enter button call this function
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const address = "0x0000000000000000000000000000000000000000";

  function formatValue(value) {
    return Number(value).toLocaleString('en', { maximumFractionDigits: 18 });
  }  

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!", {
        style: {
          background: '#4CAF50',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    }).catch((err) => {
      toast.error("Failed to copy!", {
        style: {
          background: '#f44336',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    });
  };


  return (
    <>
      <Navbar />

      {/* loader */}
      {isLoading && <Loader />}

      <div className="card-page-container">
        <header className="txn-block-search">
          <h1 className="heading-pending-txn heading-txn-block">
            Transactions
          </h1>

          {/* <RSearchBar
            onChange={handleSearch}
            onCancelSearch={() => handleSearch("")}
            placeholder="Search by Txn Hash / Block / Address"
            className="homepage-searchbar"
            style={{
              width: "50%",
              height: "38px",
            }}
          /> */}
          <div className="custom-search-cant">
            <input
              type="text"
              placeholder="Search by Txn Hash / Block / Address"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              onKeyDown={handleKeyDown}
              className="custom-search-input"
            />
            <button type="submit" className="custom-search-button" onClick={handleSearch}>
              <RiSearchLine />
            </button>
          </div>
        </header>

        {/* <div>
          <AdSense.Google
            client='ca-pub-6359692712317530'
            slot='9976828642'
          />
        </div> */}

        <div className="card-container">
          {cardData.map((card, index) => (
            <div className="top-card" key={index}>
              <div className="card-head">{card.title}</div>
              <div
                className="show-card-data"
                dangerouslySetInnerHTML={{ __html: card.value }}
              />
            </div>
          ))}
        </div>
      
        <Paper className="paper-style">
          <div className="top-pagination">
            <div className="total-blocks-count">
              <span className="total-pending-txn">
                A total of {totalCount} transactions found
              </span>
              <span className="block-record-show">
                {`Showing transactions between ${
                  page * rowsPerPage + 1
                } to ${Math.min((page + 1) * rowsPerPage, totalCount)}`}
              </span>
            </div>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell style={{ fontWeight: "bold" }}>
                    <Tooltip
                      title="See previous of the transactions details"
                      arrow
                    >
                      <span>
                        <IoHelpCircleOutline size={22} color="#6C757D" />
                      </span>
                    </Tooltip>
                  </TableCell> */}
                  <TableCell style={{ fontWeight: "bold" }}>Txn Hash</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Method <IoHelpCircleOutline size={22} color="#6C757D" />
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Block</TableCell>
                  <TableCell style={{ fontWeight: "bold", color: "#0784C3" }}>
                    Age
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>From</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>To</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>Value</TableCell>
                  <TableCell style={{ fontWeight: "bold", color: "#0784C3" }}>
                    Txn Fee
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map(
                    (row) => (
                      <TableRow key={row._id} hover>
                        {/* <TableCell className="cell-style">
                          <Button
                            variant="outlined"
                            size="small"
                            style={{
                              backgroundColor: "#F8F9FA",
                              borderRadius: 8,
                              minWidth: "28px",
                            }}
                          >
                            <FaEye />
                          </Button>
                        </TableCell> */}
                        <TableCell
                          className="cell-style"
                          style={{ cursor: "pointer" }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <Tooltip title={row?.hash} arrow>
                              <Link
                                to={`/transactions_detail/${row?.hash}`}
                                style={{
                                  color: "#0784C3",
                                  textDecoration: "none",
                                }}
                              >
                                {row?.hash.length > 16
                                ? `${row?.hash.substring(0, 8)}...${row?.hash.substring(row?.hash.length - 8)}`
                                : row?.hash}
                              </Link>
                            </Tooltip>
                            <div
                              onClick={() => copyToClipboard(row?.hash)}
                              style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                            >
                              <IoMdCopy style={{ fontSize: "1.2rem" }} />
                            </div>
                            <Toaster position="top-right"/>
                          </div>
                        </TableCell>
                        <TableCell className="cell-style">
                          {row.status === 1 ? "Success" : "Failed"}
                        </TableCell>
                        <TableCell className="cell-style">
                          <Tooltip
                            title={
                              row?.tokenData && row?.tokenData?.method
                                ? row?.tokenData?.method
                                : "Transfer"
                            }
                            arrow
                          >
                            <Button
                              variant="outlined"
                              color="default"
                              size="small"
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                                backgroundColor: "#F8F9FA",
                                borderRadius: 8,
                                textTransform: "capitalize",
                                minWidth: "90px",
                              }}
                            >
                              {row?.tokenData && row?.tokenData?.method
                                ? row?.tokenData?.method
                                : "Transfer"}
                            </Button>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                          className="cell-style"
                          style={{ cursor: "pointer" }}
                        >
                          <span
                            style={{ color: "#0784C3", cursor: "pointer" }}
                            onClick={() => {
                              history.push(`/block_details/${row.blockNumber}`);
                            }}
                          >
                            {row.blockNumber}
                          </span>
                        </TableCell>
                        <TableCell className="cell-style">
                          <Tooltip
                            title={localTimeConvert(row?.blockTimestamp)}
                            arrow
                          >
                            <span>{formatTimes(row?.blockTimestamp)}</span>
                          </Tooltip>
                        </TableCell>
                        <TableCell className="cell-style" style={{ color: "#0784C3" }}>
                          {row?.tokenData && row?.tokenData.from ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <Tooltip title={row?.tokenData?.from} arrow>
                                <Link
                                  to={`/address/${row?.tokenData?.from}`}
                                  style={{ color: "#0784C3", textDecoration: "none" }}
                                >
                                  {row?.tokenData?.from.length > 16
                                    ? `${row?.tokenData?.from.substring(0, 8)}...${row?.tokenData?.from.substring(row?.tokenData?.from.length - 8)}`
                                    : row?.tokenData?.from}
                                </Link>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(row?.tokenData?.from)}
                                style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>
                          ) : (
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <Tooltip title={row?.from} arrow>
                                <Link
                                  to={`/address/${row?.from}`}
                                  style={{ color: "#0784C3", textDecoration: "none" }}
                                >
                                  {row?.from.length > 16
                                    ? `${row?.from.substring(0, 8)}...${row?.from.substring(row?.from.length - 8)}`
                                    : row?.from}
                                </Link>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(row?.from)}
                                style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>
                          )}
                        </TableCell>
                        <TableCell
                          className="cell-style"
                          style={{ color: "#0784C3" }}
                        >
                          {row?.tokenData && row?.tokenData?.method == "burn" ? 
                           <>
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <Tooltip title={address} arrow>
                                <Link
                                  to={`/address/${address}`}
                                  style={{
                                    color: "#0784C3",
                                    textDecoration: "none",
                                  }}
                                >
                                  {address.length > 16
                                    ? `${address.substring(0, 8)}...${address.substring(address.length - 8)}`
                                    : address}
                                </Link>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(address)}
                                style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>
                           </> :
                           <>
                            {row?.tokenData && row?.tokenData.to ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.tokenData?.to} arrow>
                                  <Link
                                    to={`/address/${row?.tokenData?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.tokenData?.to.length > 16
                                    ? `${row?.tokenData?.to.substring(0, 8)}...${row?.tokenData?.to.substring(row?.tokenData?.to.length - 8)}`
                                    : row?.tokenData?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.tokenData?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.to} arrow>
                                  <Link
                                    to={`/address/${row?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.to.length > 16
                                    ? `${row?.to.substring(0, 8)}...${row?.to.substring(row?.to.length - 8)}`
                                    : row?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            )}
                           </>
                          }
                        </TableCell>
                        <TableCell className="cell-style">
                          {row?.tokenData && row?.tokenData?.value ? (
                            <Tooltip
                              title={`${formatValue(row?.tokenData?.value)} ${row?.tokenData?.token}`}
                              arrow
                            >
                              <span>
                                {formatValue(row?.tokenData?.value)}&nbsp;{row?.tokenData?.token}
                              </span>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title={formatValue(row?.value) + " AMC"}
                              arrow
                            >
                              <span>
                                {formatValue(row?.value) + " AMC"}
                              </span>
                            </Tooltip>
                          )}
                        </TableCell>
                        <TableCell className="cell-style">
                          {row?.txnFee}
                        </TableCell>
                      </TableRow>
                    )
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <div className="bottom-content">
          <p className="last-block-content">
            <img src={bulb} alt="logo" height={12.5} width={12.5} />
            Blocks are batches of transactions linked together via cryptographic
            hashes. Any tampering of a block invalidates subsequent blocks as
            their hashes would be changed.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewTransactions;
